import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.css';
import { ArchiveItemProps } from '../../DataListItemRow.types';
import { Download } from '../Download';
import { ItemName } from '../ItemName';
import { Pic } from '../Pic';
import { Archive } from '../RowFor/Archive';
import { Size } from '../Size';

const ArchiveItem = (props: ArchiveItemProps) => {
    const { isVKEmbedded, isFolder, kind, ext, name, nameWithoutExt, size, onDownload, id, storage, isEncrypted, renameAvailable } = props;
    const windowWidth = useWindowWidth();

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Archive {...props} />}
            control={
                <>
                    {/* Вернуть когда апи поддержит скачивание нескольких <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} isLarge />*/}
                    <Pic isFolder={isFolder} kind={kind} isVirus={false} ext={ext || ''} isLarge={isVKEmbedded || !isFolder} />

                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemName name={nameWithoutExt || name} ext={ext || ''} id={id} isRenameAvailable={props.renameAvailable} />
                            <Size size={size} />
                            <Download
                                onClick={onDownload}
                                ext={ext}
                                size={size}
                                id={id}
                                storage={storage}
                                isHidden={isFolder || isEncrypted}
                                isLarge
                            />
                        </>
                    ) : (
                        <>
                            {windowWidth > BREAKPOINT_SM ? (
                                <ItemName name={nameWithoutExt || name} ext={ext || ''} id={id} isRenameAvailable={renameAvailable} />
                            ) : (
                                <div className={styles.responsiveNameWrapper}>
                                    <ItemName name={nameWithoutExt || name} ext={ext || ''} id={id} />

                                    <span className={styles.responsiveDateWrapper}>
                                        <Size size={size} />
                                    </span>
                                </div>
                            )}
                            {windowWidth > BREAKPOINT_SM && <Size size={size} />}
                            <div className={styles.actionsWrapper}>
                                <Download
                                    onClick={onDownload}
                                    ext={ext}
                                    size={size}
                                    id={id}
                                    storage={storage}
                                    isHidden={isFolder || isEncrypted}
                                    isLarge
                                />
                            </div>
                        </>
                    )}
                </>
            }
        />
    );
};

export default ArchiveItem;
